export default "__VITE_ASSET__DEU705S7__"